import React from 'react';
import { Button, Dropdown } from 'react-bootstrap';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { ReactComponent as HelpIcon } from '../../../../../../shared/icons/help-icon.svg';
import {
  INTERNAL_PREPARE_FOR_SIGNING_TOOLTIP,
  SHOULD_RETURN_FOR_RECEIVER_REVIEW_TOOLTIP,
} from '../../../../../document-table/helpers/messageConstants';
import styles from '../requestReview/RequestReview.module.scss';

interface Props {
  onClick: () => void;
  disabled: boolean;
  showReturnForReviewTooltip: boolean;
  dropdownLabel?: string;
}

const SendToPreparingToSignInternal = ({ onClick, disabled, showReturnForReviewTooltip, dropdownLabel }: Props) => {
  const tooltipId = `signing-internal-tooltip-${Date.now()}-${Math.random().toString(36).substr(2, 5)}`;

  return (
    <>
      <Dropdown.Item as={Button} className={styles.signInButton} variant="link" disabled={disabled} onClick={onClick}>
        <span id={disabled ? tooltipId : undefined}>
          {dropdownLabel || 'Signing'}
          {disabled && (
            <HelpIcon className="mx-1 text-primary" style={{ width: '16px', height: '16px', marginLeft: '0.25rem' }} />
          )}
        </span>
      </Dropdown.Item>
      {disabled && (
        <ReactTooltip
          anchorSelect={`#${tooltipId}`}
          place="right"
          className="dropdown-tooltip"
          style={{
            backgroundColor: '#ddebef',
            color: '#18191b',
            maxWidth: '250px',
            minWidth: '150px',
            zIndex: 1000000,
            fontSize: '14px',
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
            padding: '10px 12px',
            borderRadius: '4px',
            whiteSpace: 'normal',
            wordBreak: 'break-word',
            lineHeight: '1.4',
            textAlign: 'left',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
          }}
          opacity={1}
        >
          {showReturnForReviewTooltip
            ? SHOULD_RETURN_FOR_RECEIVER_REVIEW_TOOLTIP
            : INTERNAL_PREPARE_FOR_SIGNING_TOOLTIP}
        </ReactTooltip>
      )}
    </>
  );
};

export default SendToPreparingToSignInternal;
